import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import { Promise } from "es6-promise-polyfill";

$(document).ready(function() {
  if (!Abacus.PreventDefault.SelectList) {
    $(".facetWidget .list").each(function() {
      Abacus.SelectList = new SelectList(this);
    });
  }
});

class SelectList extends Class {
  constructor(element, options) {
    super();
    this.element = $(element);
    this.setOptions(options);
    this.setUpEvents();
  }

  setUpEvents() {
    this.element.find("h3").on("click", function(e) {
      $(this)
        .parent()
        .hasClass("open")
        ? $(this)
            .parent()
            .removeClass("open")
        : $(this)
            .parent()
            .addClass("open");
    });
  }
}

export { SelectList };



// WEBPACK FOOTER //
// ./Javascript/core/classes/widgets.class.js